import React, { memo, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { VariableSizeList } from "react-window";
import { findIndex } from "lodash";
import { makeStyles } from "@mui/styles";

import { selectedShiftManagerSelector } from "../../reducers/ownApp/selectors";
import {
  shiftManagerEditModeSelector,
  shiftManagerEditSelector,
} from "../../reducers/shiftManagerManagement/selectors";

import { View } from "../View";
import ShiftManagerCardBase from "./ShiftManagerCardBase";

const useStyles = makeStyles(({ typography }) => ({
  item: {
    marginTop: typography.pxToRem(2),
  },
  noScrollbar: {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
}));

export const ShiftManagerList = memo(({ shiftManagers, height = 900 }) => {
  const listRef = useRef();
  const styles = useStyles();
  const selectedShiftManager = useSelector(selectedShiftManagerSelector);
  const shiftManagerEditMode = useSelector(shiftManagerEditModeSelector);
  const shiftManagerEdit = useSelector(shiftManagerEditSelector);

  useEffect(() => {
    if (!selectedShiftManager || !shiftManagers) return;
    listRef.current.resetAfterIndex(0, true);
    let selectedIndex = findIndex(
      shiftManagers,
      (shiftManager) =>
        shiftManager.shiftManagerCode === selectedShiftManager.shiftManagerCode
    );
    if (selectedIndex < 0) return;
    listRef.current.scrollToItem(selectedIndex, "start");
  }, [shiftManagers, selectedShiftManager]);

  useEffect(() => {
    listRef?.current.resetAfterIndex(0, true);
  }, [shiftManagers]);

  const renderRow = ({ index, style }) => {
    const shiftManager = shiftManagers[index];
    const inEdit =
      shiftManagerEdit?.shiftManagerCode === shiftManager.shiftManagerCode;
    const selected =
      shiftManager.shiftManagerCode === selectedShiftManager?.shiftManagerCode;
    return (
      <View
        className={styles.item}
        key={index}
        style={style}
        id={`shift-manager-card-${index}`}
      >
        <ShiftManagerCardBase
          height={style.height}
          shiftManager={shiftManager}
          editMode={shiftManagerEditMode}
          inEdit={inEdit}
          selected={selected}
        />
      </View>
    );
  };

  const getItemSize = () => 182;

  return (
    <>
      {Array.isArray(shiftManagers) && (
        <VariableSizeList
          className={styles.noScrollbar}
          ref={listRef}
          height={height}
          itemCount={shiftManagers.length}
          itemSize={getItemSize}
          width={314}
        >
          {renderRow}
        </VariableSizeList>
      )}
    </>
  );
});

export default ShiftManagerList;
